import React from 'react'
import InputTextField from './InputTextField'

const InputCode = ({
  error,
  ...others
}) => {
  return (
    <InputTextField
      label="Code"
      error={error}
      helperText={
        (error)
          ? "Ce code est invalide"
          : null
      }
      {...others}
    />
  )
}

export default InputCode
